export enum AarConditionsType {
  Mod = 1,
  Serviceable = 2,
  New = 3,
  Repaired = 4,
  Tested = 5,
  Overhauled = 6,
  Unserviceable = 7,
}

export const AarConditions = [
  { Description: "MOD", Value: AarConditionsType.Mod },
  { Description: "SERVICEABLE", Value: AarConditionsType.Serviceable },
  { Description: "NEW", Value: AarConditionsType.New },
  { Description: "REPAIRED", Value: AarConditionsType.Repaired },
  { Description: "TESTED", Value: AarConditionsType.Tested },
  { Description: "OVERHAULED", Value: AarConditionsType.Overhauled },
  { Description: "UNSERVICEABLE", Value: AarConditionsType.Unserviceable },
];
